import React, { Component } from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Setup1 from './Setup1';
import Setup2 from './Setup2';
import Setup3a from './Setup3a';
import Setup3b from './Setup3b';
import Setup4 from './Setup4';

class SignupFlow extends Component {
  constructor(props) {
    super(props);
    this.state = { completedSteps: [] };
  }

  componentDidMount() {
    window.addEventListener('popstate', this.handleBackButton);
  }
  componentWillUnmount() {
    window.removeEventListener('popstate', this.handleBackButton);
  }

  handleBackButton = () => {
    const { t } = this.props;
    const currentStep = parseInt(this.props.location.pathname.split('setup')[1], 10);

    if (window.confirm(t('signupFlow:confirmBack'))) {
      if (currentStep === 2) {
        this.props.history.push('/signup');
      } else if (currentStep === 3) {
        this.props.history.replace('/signup-flow/setup2');
      } else if (currentStep > 1) {
        this.props.history.push(`/signup-flow/setup${currentStep - 1}`);
      } else {
        this.props.history.push('/signup');
      }
    } else {
      this.props.history.push(this.props.location.pathname);
    }
  };

  goToStep = (step) => {
    const currentStep = parseInt(this.props.location.pathname.split('setup')[1], 10);

    if (!this.state.completedSteps.includes(currentStep)) {
      this.setState((prev) => ({ completedSteps: [...prev.completedSteps, currentStep] }));
    }

    if (step === 3) {
      this.props.history.replace('/signup-flow/setup3a');
    } else {
      this.props.history.push(`/signup-flow/setup${step}`);
    }
  };

  goBack = () => {
    const { pathname } = this.props.location;
    const currentStep = parseInt(pathname.split('setup')[1], 10);

    if (currentStep === 2) {
      this.props.history.push('/signup');
    } else if (currentStep === 3) {
      this.props.history.replace('/signup-flow/setup2');
    } else if (currentStep > 1) {
      this.props.history.push(`/signup-flow/setup${currentStep - 1}`);
    }
  };

  render() {
    const stepNum = parseInt(this.props.location.pathname.split('setup')[1] || '1', 10);
    const { t } = this.props;

    return (
      <div className="signup-container">
        {/* Progress Bar */}
        <div className="progress-bar">
          <div className="stepper">
            {/* Step 1 */}
            <div className="step">
              <div
                className={`circle ${stepNum >= 1 ? 'completed' : ''} ${this.props.location.pathname.includes('setup1') ? 'active' : ''}`}
              >
                1
              </div>
              <div className="step-info" data-mobile-text={t('signupFlow:mobile.phone')}>
                <h4>{t('signupFlow:steps.1.title')}</h4>
                <p>{t('signupFlow:steps.1.desc')}</p>
              </div>
            </div>

            <div className="line"></div>

            {/* Step 2 */}
            <div className="step">
              <div
                className={`circle ${stepNum >= 2 ? 'completed' : ''} ${this.props.location.pathname.includes('setup2') ? 'active' : ''}`}
              >
                2
              </div>
              <div className="step-info" data-mobile-text={t('signupFlow:mobile.setup')}>
                <h4>{t('signupFlow:steps.2.title')}</h4>
                <p>{t('signupFlow:steps.2.desc')}</p>
              </div>
            </div>

            <div className="line"></div>

            {/* Step 3 */}
            <div className="step">
              <div
                className={`circle ${
                  (this.props.location.pathname.includes('setup3a') || this.props.location.pathname.includes('setup3b')) ? 'active' : ''
                } ${stepNum >= 3 ? 'completed' : ''}`}
              >
                3
              </div>
              <div className="step-info" data-mobile-text={t('signupFlow:mobile.scan')}>
                <h4>{t('signupFlow:steps.3.title')}</h4>
                <p>{t('signupFlow:steps.3.desc')}</p>
              </div>
            </div>

            <div className="line"></div>

            {/* Step 4 */}
            <div className="step">
              <div
                className={`circle ${stepNum >= 4 ? 'completed' : ''} ${this.props.location.pathname.includes('setup4') ? 'active' : ''}`}
              >
                4
              </div>
              <div className="step-info" data-mobile-text={t('signupFlow:mobile.face')}>
                <h4>{t('signupFlow:steps.4.title')}</h4>
                <p>{t('signupFlow:steps.4.desc')}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Step Content */}
        <div className="step-content">
          <Switch>
            <Route
              exact
              path="/signup-flow/setup1"
              component={() => <Setup1 goToStep={this.goToStep} goBack={this.goBack} />}
            />
            <Route
              exact
              path="/signup-flow/setup2"
              component={() => <Setup2 goToStep={() => this.goToStep(3)} goBack={this.goBack} />}
            />
            <Route
              exact
              path="/signup-flow/setup3a"
              component={() => <Setup3a goToStep={this.goToStep} goBack={this.goBack} />}
            />
            <Route
              exact
              path="/signup-flow/setup3b"
              component={() => <Setup3b goToStep={this.goToStep} goBack={this.goBack} />}
            />
            <Route
              exact
              path="/signup-flow/setup4"
              component={() => <Setup4 goToStep={this.goToStep} goBack={this.goBack} />}
            />
            <Route path="*" component={() => <Setup1 goToStep={this.goToStep} goBack={this.goBack} />} />
          </Switch>
        </div>
      </div>
    );
  }
}

// withTranslation should wrap BEFORE withRouter on this component
export default withRouter(withTranslation(['signupFlow'])(SignupFlow));
